import React from 'react';
import TableHeader from './TableHeader';
import TableRow from './TableRow';

const ProductionPerformance = () => {
  const tableData = [
    {
      scope: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit,',
      hoursUsed: '100%',
      unitsPlaced: '100%',
      crewSize: '16',
      estCrewDays: '16',
      productionPerDay: '16',
      crewDaysUsed: '16',
      rentalEquipment: 'Forklift/ Crain',
      rentalEquipmentDays: '12/9'
    },
    {
      scope: 'Scope #2',
      hoursUsed: '100%',
      unitsPlaced: '100%',
      crewSize: '16',
      estCrewDays: '16',
      productionPerDay: '16',
      crewDaysUsed: '16',
      rentalEquipment: 'Forklift/ Crain',
      rentalEquipmentDays: '12/9'
    },
    {
      scope: 'Scope #3',
      hoursUsed: '100%',
      unitsPlaced: '100%',
      crewSize: '16',
      estCrewDays: '16',
      productionPerDay: '16',
      crewDaysUsed: '16',
      rentalEquipment: 'Forklift/ Crain',
      rentalEquipmentDays: '12/9'
    },
    {
      scope: 'Scope #4',
      hoursUsed: '100%',
      unitsPlaced: '100%',
      crewSize: '16',
      estCrewDays: '16',
      productionPerDay: '16',
      crewDaysUsed: '16',
      rentalEquipment: 'Forklift/ Crain',
      rentalEquipmentDays: '12/9'
    },
    {
      scope: 'Scope #5',
      hoursUsed: '100%',
      unitsPlaced: '100%',
      crewSize: '16',
      estCrewDays: '16',
      productionPerDay: '16',
      crewDaysUsed: '16',
      rentalEquipment: 'Forklift/ Crain',
      rentalEquipmentDays: '12/9'
    }
  ];

  return (
    <div className="flex flex-col px-4 py-4 mt-4 mx-auto rounded-xl bg-stone-50 max-w-full overflow-x-auto">
      <h2 className="text-xl font-semibold text-zinc-800 mb-4">
        Production Performance
      </h2>
      <div className="w-full text-lg text-center text-zinc-800">
        <TableHeader />
        {tableData.map((row, index) => (
          <TableRow key={index} data={row} isEven={index % 2 === 0} />
        ))}
      </div>
    </div>
  );
};

export default ProductionPerformance;